/**
 * Zustand store barrel (Perf 3.1.b — store/API split).
 * As of Step 5 every store lives in its own leaf module under store/. This file
 * only imports the leaves and re-exports them (plus a few shared constants) so
 * the hundreds of existing `@/store` importers across the app stay unchanged.
 * Import a specific leaf (e.g. `@/store/agent`) to avoid pulling the whole graph.
 */
import { useAuthStore } from './auth';
import { useUIStore } from './ui';
import { useRouteStore } from './route';
import { useLightboxStore } from './lightbox';
import { useModalStore } from './modal';
import { useToastStore } from './toast';
import { useCollectionStore } from './collection';
import { useChatStore } from './chat';
import { useChatInputStore } from './chatInput';
import { useFileStore } from './file';
import { useInferenceTasksStore } from './inferenceTasks';
import { useTaskTemplatesStore } from './taskTemplates';
import { useAgentStore } from './agent';
import { useModelStore } from './model';
import { useCompanyStore } from './company';
import { useExploreLightboxStore } from './exploreLightbox';
import { useCreditPacksStore } from './creditPacks';
import { useMemoryStore } from './memory';
import { useOnboardingStore } from './onboarding';
import { useVoiceModeStore } from './voiceMode';
import { useDeckStore } from './deck';
import { useBookmarkStore } from './bookmark';
import { useExploreStore } from './explore';
import { useToolStore } from './tool';
import { usePromptStore } from './prompt';
import { useCoworkerStore } from './coworker';
import { FILTER_CONFIGS } from './filterConfigs';

// Shared constants — defined in their owning leaf, re-exported here for back-compat.
export { HEARTBEAT_INTERVAL_MS, VOICE_MODE_STATES, DEFAULT_VOICES as VOICE_MODE_VOICES, CREDITS_PER_MINUTE } from './voiceMode';
export { FILTER_CONFIGS };

// Export all stores
export {
  useAuthStore,
  useCollectionStore,
  useChatStore,
  useUIStore,
  useRouteStore,
  useAgentStore,
  useModelStore,
  useModalStore,
  useToastStore,
  useLightboxStore,
  useCompanyStore,
  useChatInputStore,
  useFileStore,
  useCreditPacksStore,
  useOnboardingStore,
  useInferenceTasksStore,
  useTaskTemplatesStore,
  useMemoryStore,
  useVoiceModeStore,
  useDeckStore,
  useBookmarkStore,
  useExploreStore,
  useExploreLightboxStore,
  useToolStore,
  usePromptStore,
  useCoworkerStore,
};
